module.exports = __webpack_public_path__ + "static/media/arayan_jotshi.dc989718.jpeg";